export default __webpack_public_path__ + "static/media/crisis_life_line-1.d79a0cc4.jpeg";